import React from 'react';

/** Fabricator / blueprint icon — user-provided asset (mask + currentColor). */
export default function PersonalHubBlueprintIcon({ className = '' }) {
  return (
    <span
      className={['personal-hub-rail__blueprint-icon', className].filter(Boolean).join(' ')}
      aria-hidden="true"
    />
  );
}
